import React from 'react';
import styled, { css } from 'styled-components';
import { glsp, themeVal } from '@devseed-ui/theme-provider';
import { Button } from '@devseed-ui/button';
import { CollecticonExpandTopRight } from '@devseed-ui/collecticons';

const Frame = styled.div<{ $withShadow?: boolean }>`
  /* margin: ${glsp()}; */
  border-radius: ${themeVal('shape.rounded')};
  overflow: hidden;
  background: ${themeVal('color.base-200')};

  ${({ $withShadow }) =>
    $withShadow &&
    css`
      box-shadow: ${themeVal('boxShadow.elevationB')};
    `}

  img, video {
    max-width: 100%;
    display: block;
  }
`;

const FrameHeader = styled.div`
  padding: ${glsp(0.5, 0.75)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${glsp()};
`;

const Dots = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const Dot = styled.span<{ $bg?: string | false }>`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: ${themeVal('shape.ellipsoid')};
  background: ${({ $bg }) => $bg || themeVal('color.base-300')};
`;

const UrlBar = styled.p`
  padding: ${glsp(0, 0.5)};
  height: 1.5rem;
  font-size: 0.75rem;
  color: ${themeVal('color.base-400')};
  display: flex;
  align-items: center;
`;

const Controls = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: ${glsp(0.5)};
`;

const FrameContent = styled.div`
  overflow: hidden;
  border-radius: ${themeVal('shape.rounded')};
  margin: ${glsp(0, 0.125, 1, 0.125)};
`;

export interface BrowserFrameProps {
  title?: string;
  url?: string;
  noShadow?: boolean;
  noColor?: boolean;
  children: React.ReactNode;
}

function BrowserFrameCmp(props: BrowserFrameProps) {
  const { title, url, noShadow, noColor, children, ...rest } = props;

  if (!children) {
    return null;
  }

  return (
    <Frame $withShadow={!noShadow} {...rest}>
      <FrameHeader>
        <Dots>
          <Dot $bg={!noColor && '#FE5F57'} />
          <Dot $bg={!noColor && '#FEBC2E'} />
          <Dot $bg={!noColor && '#2BC840'} />
        </Dots>
        {title && <UrlBar>{title}</UrlBar>}
        <Controls style={{ width: '40px' }}>
          {url && (
            <Button
              forwardedAs='a'
              href={url}
              variation='base-text'
              fitting='skinny'
              size='small'
              target='_blank'
              rel='noopener noreferrer'
            >
              <CollecticonExpandTopRight
                meaningful
                title='Open url in new tab'
              />
            </Button>
          )}
        </Controls>
      </FrameHeader>
      <FrameContent>{children}</FrameContent>
    </Frame>
  );
}

export const BrowserFrame = styled(BrowserFrameCmp)``;
